import '@styles/common.less';
import '@styles/layout.less';
import './partner.less';
import '@common';

import LazyLoad from 'vanilla-lazyload';

new LazyLoad({
  elements_selector: '.lazy',
  threshold: 300,
});
